import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import React, { useContext, useState, useEffect } from 'react';

import Context from './Context';
import List from './Routes/List';
import Record from './Routes/Record';
import Sidebar from './Containers/Sidebar';
import BulkSelect from './Routes/BulkSelect';
import MainContainer from './Containers/Main';
import HeaderContainer from './Containers/HeaderContainer';
import GreetRedirect from './Routes/GreetRedirect';
import MainOuterContainer from './Containers/MainOuter';
import RedirectToGreet, {
  RedirectToGreetUpload,
} from './Components/RedirectToGreet';
import Header from './Components/Header/Header';
import BulkSelectHeader from './Components/Header/BulkSelect';
import { Loading as GreetLoading } from '~/App/Modules/Common/Components/Greet/Loading';

function Desktop() {
  const { showFallback, bulkSelect, selectedGreets } = useContext(Context);
  const [bulkSelectAll, setBulkSelectAll] = useState(false);

  useEffect(() => {
    if (bulkSelectAll && !bulkSelect.data.any) {
      setBulkSelectAll(false);
    }
  }, [bulkSelect]);

  const HeaderComponent = () => {
    if (bulkSelect.data.any) {
      return (
        <Route
          render={(props) => (
            <BulkSelectHeader
              {...props}
              bulkSelectAll={bulkSelectAll}
              setBulkSelectAll={setBulkSelectAll}
            />
          )}
        />
      );
    }
    return <Route component={Header} />;
  };

  return (
    <React.Fragment>
      <Sidebar>
        <HeaderContainer>
          <Switch>
            <HeaderComponent />
          </Switch>
        </HeaderContainer>
        <Route component={List} />
      </Sidebar>
      <MainOuterContainer>
        <MainContainer>
          <Switch>
            <Route
              exact
              path='/home/greet/redirect'
              component={GreetRedirect}
            />
            <Route exact path='/home/greet/:id/upload' component={Record} />
            <Route exact path='/home/greet/:id' component={Record} />
            <Route exact path='/home/bulk-select'>
              <BulkSelect
                selectedGreets={selectedGreets}
                count={bulkSelect.data.count}
              />
            </Route>
            {showFallback && <Route component={GreetLoading} />}
            <Route
              exact
              path='/home/upload'
              component={RedirectToGreetUpload}
            />
            <Route component={RedirectToGreet} />
          </Switch>
        </MainContainer>
      </MainOuterContainer>
    </React.Fragment>
  );
}

export default withRouter(Desktop);
